import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTrainerAvailabilityRequestPayload, trainerAvailabilityApi } from "api/trainers/trainerAvailabilityApi";
import { QUERIES_KEYS } from "queries";

export const useCreateAvailabilityRequest = (trainerId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateTrainerAvailabilityRequestPayload) =>
      trainerAvailabilityApi.createAvailabilityRequest(trainerId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_AVAILABILITY_REQUESTS(trainerId) });
    },
  });
};
